var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayee2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 707,
    height: 150,
    viewBox: "0 0 707 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M705.987 1C648.487 92.6669 479.387 236.201 262.987 77.0008C107.026 -37.7356 9.56891 9.6208 -42 81.0856",
    stroke: "url(#paint0_linear_9430_124055)",
    strokeWidth: 2,
    strokeDasharray: "10 10"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 45.988,
    width: 64.2082,
    height: 64.2082,
    rx: 17.8765,
    fill: "#007AFF",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M137.728 73.6553L132.907 76.9917C132.762 77.0925 132.591 77.1462 132.416 77.1462H127.24C126.889 77.1596 126.612 77.4581 126.612 77.8218C126.612 78.1855 126.889 78.4841 127.24 78.4975H132.882C133.01 78.4975 133.135 78.4581 133.242 78.3843L138.45 74.7794C138.644 74.6455 138.754 74.4146 138.739 74.1738C138.724 73.9329 138.586 73.7187 138.378 73.6117C138.169 73.5048 137.922 73.5214 137.728 73.6553Z",
    fill: "#007AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.728 76.5833L132.907 79.9169C132.762 80.0177 132.591 80.0715 132.416 80.0714H127.24C126.88 80.0714 126.588 80.3741 126.588 80.7475C126.588 81.1209 126.88 81.4236 127.24 81.4236H132.882C133.01 81.4235 133.135 81.3841 133.242 81.3105L138.45 77.7092C138.649 77.5777 138.764 77.3447 138.751 77.1002C138.737 76.8557 138.598 76.6379 138.385 76.5308C138.173 76.4237 137.922 76.4442 137.728 76.5842V76.5833Z",
    fill: "#007AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M137.728 79.5122L132.907 82.8485C132.762 82.9493 132.591 83.0031 132.416 83.003H127.24C126.889 83.0165 126.612 83.315 126.612 83.6787C126.612 84.0424 126.889 84.3409 127.24 84.3543H132.882C133.012 84.3554 133.139 84.3156 133.247 84.2403L138.455 80.6362C138.654 80.5047 138.769 80.2717 138.755 80.0272C138.742 79.7827 138.602 79.5649 138.39 79.4578C138.178 79.3508 137.926 79.3712 137.733 79.5113L137.728 79.5122Z",
    fill: "#007AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.467 77.1462H118.127C117.889 77.1371 117.665 77.2638 117.543 77.4766C117.421 77.6894 117.421 77.9543 117.543 78.1671C117.665 78.3799 117.889 78.5066 118.127 78.4975H122.468C122.818 78.4841 123.096 78.1856 123.096 77.8219C123.096 77.4582 122.818 77.1596 122.468 77.1462H122.467Z",
    fill: "#007AFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.467 80.0742H118.127C117.767 80.0742 117.476 80.3768 117.476 80.7502C117.476 81.1236 117.767 81.4263 118.127 81.4263H122.468C122.828 81.4263 123.12 81.1236 123.12 80.7502C123.12 80.3768 122.828 80.0742 122.468 80.0742H122.467Z",
    fill: "#007AFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.467 83.003H118.127C117.889 82.9939 117.665 83.1206 117.543 83.3334C117.421 83.5462 117.421 83.8111 117.543 84.0239C117.665 84.2367 117.889 84.3634 118.127 84.3543H122.468C122.818 84.3409 123.096 84.0423 123.096 83.6786C123.096 83.315 122.818 83.0164 122.468 83.003H122.467Z",
    fill: "#007AFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.679 75.1188C127.679 75.2383 127.724 75.3528 127.806 75.4372C127.887 75.5216 127.998 75.5689 128.113 75.5686H132.881C132.967 75.5689 133.05 75.5426 133.122 75.4932L138.33 71.8892C138.491 71.7797 138.563 71.5731 138.507 71.3817C138.452 71.1902 138.281 71.0598 138.089 71.0613H133.316C133.23 71.061 133.146 71.0873 133.075 71.1368L127.872 74.7399C127.751 74.8254 127.679 74.9672 127.679 75.1188Z",
    fill: "#007AFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.524 71.3842C128.468 71.1939 128.299 71.0638 128.108 71.0641H123.37C123.285 71.0639 123.201 71.0901 123.13 71.1395L117.927 74.7398C117.768 74.8509 117.698 75.0564 117.753 75.2465C117.809 75.4366 117.977 75.5669 118.169 75.5677H122.9C122.986 75.568 123.07 75.5418 123.141 75.4923L128.349 71.8883C128.507 71.7783 128.578 71.5738 128.524 71.3842Z",
    fill: "#007AFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383,
    y: 33.9971,
    width: 49.0054,
    height: 49.0054,
    rx: 13.6438,
    fill: "#007AFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M414.848 55.1135L411.169 57.6599C411.058 57.7368 410.927 57.7778 410.794 57.7778H406.843C406.576 57.788 406.364 58.0159 406.364 58.2935C406.364 58.571 406.576 58.7989 406.843 58.8091H411.149C411.247 58.8091 411.343 58.7791 411.424 58.7228L415.399 55.9714C415.547 55.8692 415.631 55.693 415.619 55.5092C415.608 55.3253 415.503 55.1618 415.344 55.0802C415.185 54.9986 414.996 55.0113 414.848 55.1135Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.848 57.3482L411.169 59.8925C411.058 59.9694 410.927 60.0104 410.794 60.0104H406.843C406.569 60.0104 406.346 60.2414 406.346 60.5264C406.346 60.8114 406.569 61.0424 406.843 61.0424H411.149C411.247 61.0423 411.343 61.0123 411.425 60.9561L415.4 58.2075C415.551 58.1071 415.639 57.9293 415.629 57.7427C415.619 57.5561 415.512 57.3898 415.35 57.3081C415.188 57.2264 414.996 57.242 414.848 57.3489V57.3482Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M414.848 59.5836L411.169 62.1299C411.058 62.2069 410.927 62.2479 410.794 62.2479H406.843C406.576 62.2581 406.364 62.486 406.364 62.7636C406.364 63.0411 406.576 63.269 406.843 63.2792H411.149C411.248 63.28 411.346 63.2497 411.428 63.1922L415.403 60.4415C415.555 60.3411 415.642 60.1633 415.632 59.9767C415.622 59.79 415.515 59.6238 415.353 59.5421C415.191 59.4604 414.999 59.476 414.852 59.5829L414.848 59.5836Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M403.2 57.7778H399.888C399.706 57.7709 399.535 57.8676 399.442 58.03C399.349 58.1924 399.349 58.3945 399.442 58.557C399.535 58.7194 399.706 58.8161 399.888 58.8091H403.201C403.469 58.7989 403.68 58.5711 403.68 58.2935C403.68 58.0159 403.469 57.7881 403.201 57.7778H403.2Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.2 60.0125H399.888C399.614 60.0125 399.391 60.2435 399.391 60.5285C399.391 60.8135 399.614 61.0445 399.888 61.0445H403.202C403.476 61.0445 403.699 60.8135 403.699 60.5285C403.699 60.2435 403.476 60.0125 403.202 60.0125H403.2Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M403.2 62.2479H399.888C399.706 62.2409 399.535 62.3376 399.442 62.5C399.349 62.6625 399.349 62.8646 399.442 63.027C399.535 63.1894 399.706 63.2862 399.888 63.2792H403.201C403.469 63.269 403.68 63.0411 403.68 62.7635C403.68 62.4859 403.469 62.2581 403.201 62.2479H403.2Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.178 56.2305C407.178 56.3216 407.213 56.4091 407.275 56.4735C407.337 56.5379 407.422 56.5739 407.51 56.5738H411.149C411.214 56.5739 411.278 56.5539 411.332 56.5162L415.307 53.7655C415.43 53.6819 415.485 53.5242 415.443 53.3781C415.4 53.232 415.27 53.1325 415.123 53.1337H411.48C411.415 53.1334 411.351 53.1534 411.296 53.1912L407.326 55.9412C407.234 56.0065 407.178 56.1147 407.178 56.2305Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.823 53.3801C407.781 53.2348 407.652 53.1355 407.506 53.1358H403.89C403.825 53.1356 403.761 53.1556 403.707 53.1933L399.735 55.9412C399.614 56.0259 399.56 56.1828 399.603 56.3279C399.645 56.473 399.774 56.5724 399.92 56.573H403.531C403.596 56.5733 403.66 56.5533 403.715 56.5155L407.69 53.7648C407.811 53.6808 407.865 53.5248 407.823 53.3801Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9430_124055",
    x1: -42,
    y1: 74.7324,
    x2: 705.987,
    y2: 74.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#007AFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayee2);
export default __webpack_public_path__ + "static/media/payee2.924fb6e9bfe07b5920395d9cc69038fa.svg";
export { ForwardRef as ReactComponent };